/**
 * Seasonal promotion: a free 2027 Hyundai Staria van with every September &
 * October stay. This is the single source of truth for the offer so the
 * homepage banner, the dedicated /september-offer landing page and the
 * date-aware booking callout all stay in sync.
 *
 * To end the promo, set `active: false` (everything hides automatically). To
 * change the window, edit `startDate` / `endDate` (inclusive, local dates).
 */

export const promo = {
  active: true,

  // Stays with a check-in date within this window (inclusive) qualify.
  startDate: "2026-09-01",
  endDate: "2026-10-31",

  // Short label for compact spots (e.g. the homepage banner pill).
  shortLabel: "Sept & Oct offer",

  // Human-readable window used in copy.
  windowLabel: "September & October 2026",

  // Primary marketing lines.
  headline: "Your September or October stay comes with a free 2027 van",
  bannerText: "Book a September or October stay and the brand-new 2027 van is on us.",

  // One reusable exclusion line shown everywhere the offer appears, so the
  // "van only" scope is always crystal clear.
  terms:
    "Free van applies to stays checking in Sept 1 \u2013 Oct 31, 2026. Van rental only \u2014 " +
    "two-way airport transfers and the Toyota RAV4 are separate paid add-ons.",

  // Where the banner / CTAs point.
  ctaPath: "/september-offer",
};

// Convert a Date to a comparable local YYYYMMDD integer.
const toYmdInt = (d) => d.getFullYear() * 10000 + (d.getMonth() + 1) * 100 + d.getDate();

// Convert a "YYYY-MM-DD" config string to the same YYYYMMDD integer.
const strToYmdInt = (s) => Number(s.replace(/-/g, ""));

/**
 * True when a check-in Date falls within the promo window (inclusive).
 * Uses local date parts so it matches the date the guest sees selected in the
 * calendar (no timezone drift).
 */
export function isPromoStay(checkIn) {
  if (!promo.active || !checkIn) return false;
  const date = checkIn instanceof Date ? checkIn : new Date(checkIn);
  if (Number.isNaN(date.getTime())) return false;
  const value = toYmdInt(date);
  return value >= strToYmdInt(promo.startDate) && value <= strToYmdInt(promo.endDate);
}

export default promo;
